module.exports = __webpack_public_path__ + "static/media/pixeltrue-search.72b56ca3.svg";